import CSelect from "../CSelect";
import styles from "./AccountSelect.module.scss";
import classNames from "classnames";
import { useExchangeAccounts } from "src/hook/useExchangeAccounts";
import { useEffect, useState } from "react";
import { useExchangeInfoStore } from "src/store";
import { useLocation } from "react-router-dom";

type AccountSelectProps = {
  classname?: string;
};

export default function AccountSelect(props: AccountSelectProps) {
  const store = useExchangeInfoStore();
  const exchangeAccounts = useExchangeAccounts();

  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    let selectableExchangeAccounts = exchangeAccounts.myExchangeAccounts;

    // 根据 selectedExchangeKey 过滤账户
    if (store.selectedExchangeKey || store.exchanges) {
      const selectedExchangeId = store.exchanges.find((exchange) => exchange.key === store.selectedExchangeKey)?.id;
      if (!!selectedExchangeId) {
        selectableExchangeAccounts = selectableExchangeAccounts.filter(
          (account) => account.exchangeId === selectedExchangeId
        );
      }
    }

    // 根据 selectedSpotPair 过滤账户
    if (store.selectedSpotPair && !currentPath.includes("perpeptual")) {
      console.log("second", store.selectedSpotPair, selectableExchangeAccounts);
      selectableExchangeAccounts = selectableExchangeAccounts.filter((account) => {
        return account.alias.toLowerCase().includes(store.selectedSpotPair.base.toLowerCase());
      });
    }

    const newOptions = selectableExchangeAccounts.map((account) => {
      return {
        value: String(account.id),
        label: account.alias || String(account.id),
      };
    });

    setOptions(newOptions);

    // 如果当前选中的账户不在新的选项中，自动选择第一个账户
    const newSelectedOption = newOptions.find((option) => option.value === String(store.selectedExchangeAccountId));
    if (!newSelectedOption && newOptions.length > 0) {
      store.setSelectedExchangeAccountId(Number(newOptions[0].value));
      setSelectedOption(newOptions[0]);
    } else {
      setSelectedOption(newSelectedOption);
    }
  }, [
    store.selectedExchangeKey,
    exchangeAccounts.myExchangeAccounts,
    store.selectedExchangeAccountId,
    store.exchanges,
    store,
  ]);

  const handleChange = (selectedOption) => {
    store.setSelectedExchangeAccountId(Number(selectedOption.value)); // 更新状态
    setSelectedOption(selectedOption); // 更新本地选中状态
  };

  return (
    <CSelect
      classname={classNames(styles.container, props.classname)}
      label={"交易账户"}
      placeholder="选择账户"
      options={options}
      onChange={handleChange}
      value={selectedOption} // 使用 value 替代 defaultValue
    />
  );
}
